<div class="app__title">
    <h1>Projects</h1>
</div>

<app-project-financial-graphs></app-project-financial-graphs>
